// extracted by mini-css-extract-plugin
module.exports = {"cta":"CTA_cta__1Se48","ctaHeading":"CTA_ctaHeading__1ouNa","heading":"CTA_heading__3-pDk","icon":"CTA_icon__3zwLJ"};